import { SECONDS_IN_DAY } from "../unit-utils/time";

export function daysToSeconds(days: number): number {
    if (!isFinite(days) || isNaN(days)) {
        return 0;
    }

    return days * SECONDS_IN_DAY;
}
